/**
 * Une clases condicionales sin sumar dependencias al bundle.
 * (equivalente mínimo a clsx: ignora false | null | undefined)
 */
export type ClassValue = string | false | null | undefined;

export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(" ");
}

export default cn;
